import React, { useState, useEffect } from 'react';

import { getRequest } from 'utils/api';
import Matches from './Matches';

const FollowingList = ({ followingList, setFollowingList }) => {
  const [hasMoreFollowing, setHasMoreFollowing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const updateFollowingListGig = gig => {
    setFollowingList(prevState => prevState.filter(g => g.id !== gig.id));

    if (!gig.following) {
      setPerfectMatchList(prevState => prevState.map(g => (g.id === gig.id ? gig : g)));
      setCloseMatchList(prevState => prevState.map(g => (g.id === gig.id ? gig : g)));
    }
  };

  useEffect(() => {
    setIsLoading(true);

    getRequest({
      endpoint: 'gigs/following',
      query: { per_page: 5 },
      resolveResponse: true,
    })
      .then(response => {
        const data = response.status === 204 ? [] : response.data;
        const count = response.headers['pagination-total-count'] || 0;

        setHasMoreFollowing(+count > 5);
        setFollowingList(data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));

    return () => setIsLoading(false);
  }, [setFollowingList]);

  return (
    <Matches
      gigs={followingList}
      updateGig={updateFollowingListGig}
      link="discover/following"
      title="Favorites"
      hasMore={hasMoreFollowing}
      isLoading={isLoading}
    />
  );
};

export default FollowingList;
